export default __webpack_public_path__ + "static/media/crawle-v2.2@3x.970c55ea.png";